/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
 import PRM from "@/core/PermissionConstants";
 import  RouteConstants from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.OPTOMETRY_PENDING.path,
  name: RouteConstants.OPTOMETRY_PENDING.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/OptometryPendingService"),
    table: () => import("@/app/components/optometry/pending/OptometryPendingTable"),
    form: () => import("@/app/components/optometry/pending/OptometryPendingForm"),

    header: {
      icono: "mdi-eye",
      texto: "Consultas pendientes | Optometría",
      textNew: "Atender Consulta | Optometría",
      textEdit: "Editar Consulta | Optometría",
      textView: "Visualizar consulta | Optometría"
    },
    prm: PRM.MODULE_OPTOMETRY_PENDING,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    saveButton: "Finalizar Consulta",
    labelDate: "Seleccione fecha",
    namePDF: "Optometría",
    module: "optometria"
  },
};
